// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-cargo-form .el-col {\n  margin-bottom: 0 !important;\n}\n.add-cargo-form .el-form-item__label {\n  padding-bottom: 0;\n}\n", ""]);
// Exports
module.exports = exports;
